(function ($) {
	var x, i, j, l, ll, selElmnt, a, b, c, d, e, f;
	/* Look for any element with the class "custom-select" */
	x = document.getElementsByClassName("brinova-select");
	l = x.length;

	for (i = 0; i < l; i++) {
		selElmnt = x[i].getElementsByTagName("select")[0];
		ll = selElmnt.length;

		/* For each element, create a new DIV that will act as the selected item */
		a = document.createElement("DIV");
		a.setAttribute("class", "select-selected");
		a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
		x[i].appendChild(a);

		/* For each element, create a new DIV that will contain the option list */
		b = document.createElement("DIV");
		b.setAttribute("class", "select-items select-hide");

		for (j = 1; j < ll; j++) {
			/* For each option in the original select element,
			create a new DIV that will act as an option item */
			c = document.createElement("DIV");
			c.classList.add('item-wrapper');
			d = document.createElement("DIV");
			d.classList.add('form-img-wrapper');
			e = document.createElement("IMG");

			if ('Bostad' === selElmnt.options[j].innerHTML) {
				e.src = "/wp-content/themes/brinova/assets/dist/svg/House-Heart-blue.svg";
			} else if ('Lokal' === selElmnt.options[j].innerHTML) {
				e.src = "/wp-content/themes/brinova/assets/dist/svg/Building 2.svg";
			} else if ('Förråd' === selElmnt.options[j].innerHTML) {
				e.src = "/wp-content/themes/brinova/assets/dist/svg/Building 2.svg";
			} else if ('Parkeringsplats' === selElmnt.options[j].innerHTML) {
				e.src = "/wp-content/themes/brinova/assets/dist/svg/Three Pin Parking.svg";
			} else {
				e.src = "/wp-content/themes/brinova/assets/dist/svg/location-point-blue.svg";
			}

			e.classList.add('img-fluid');
			d.appendChild(e);
			c.appendChild(d);
			f = document.createElement("P");
			f.innerHTML = selElmnt.options[j].innerHTML;
			f.setAttribute('data-slug', selElmnt.options[j].value);
			c.appendChild(f);

			//c.innerHTML = selElmnt.options[j].innerHTML;
			c.addEventListener("click", function (e) {
				/* When an item is clicked, updated the original select box,
				and the selected item */
				var y, i, k, s, h, sl, yl;
				s = this.parentNode.parentNode.getElementsByTagName("select")[0];
				sl = s.length;
				h = this.parentNode.previousSibling;

				for (i = 0; i < sl; i++) {
					if (s.options[i].innerHTML == this.lastChild.innerHTML) {
						s.selectedIndex = i;
						h.innerHTML = this.lastChild.innerHTML;
						h.setAttribute('data-slug', s.options[i].value);
						y = this.parentNode.getElementsByClassName("same-as-selected");
						yl = y.length;
						this.setAttribute("class", "same-as-selected");

						for (k = 0; k < yl; k++) {
							y[k].classList.add("item-wrapper");
							y[k].classList.remove("same-as-selected");
						}
						break;
					}
				}
				h.click();
			});
			b.appendChild(c);
		}
		x[i].appendChild(b);
		a.addEventListener("click", function (e) {
			/* When the select box is clicked, close any other select boxes,
			and open/close the current select box */
			e.stopPropagation();
			closeAllSelect(this);

			if (375 >= $(window).width()) {
				$('.select-items').toggleClass('open');
			}

			this.nextSibling.classList.toggle("select-hide");
			this.classList.toggle("select-arrow-active");
			$('form .form-row').toggleClass('background');
			$('form .border').toggleClass('not-active');
		});
	}

	function closeAllSelect(elmnt) {
		/* A function that will close all select boxes in the document,
		except the current select box */
		var x, y, i, xl, yl, arrNo = [];
		x = document.getElementsByClassName("select-items");
		y = document.getElementsByClassName("select-selected");

		if ($('form.brinova-form .form-row').hasClass('background')) {
			$('form .form-row').removeClass('background');
		}

		if ($('form.brinova-form .border').hasClass('not-active')) {
			$('form .border').removeClass('not-active');
		}

		xl = x.length;
		yl = y.length;

		for (i = 0; i < yl; i++) {
			if (elmnt == y[i]) {
				arrNo.push(i);
			} else {
				y[i].classList.remove("select-arrow-active");
			}
		}

		if (576 < $(window).width()) {
			for (i = 0; i < xl; i++) {
				if (arrNo.indexOf(i)) {
					x[i].classList.add("select-hide");
				}
			}

			$('.select-items').removeClass('open');
		}
	}

	/* If the user clicks anywhere outside the select box,
	then close all select boxes */
	document.addEventListener("click", closeAllSelect);

	$(document).ready(function () {

		// Header nav
		if ($('body').hasClass('home')) {
			$(window).scroll(function () {
				scroll_pos = $(this).scrollTop();
				let imgUrl;
				if (scroll_pos >= 20) {
					$('#site-header').css('background', '#ffffff');
					$('#site-header').css('box-shadow', '1px 5px 10px 0px rgba(166,166,166,0.75)');
					$('#primary-menu .menu-item a').css('color', '#212121');
					$('#primary-menu .dropdown-menu .menu-item a').css('color', '#212121');
					imgUrl = '/wp-content/themes/brinova/assets/dist/images/brinova-pos.png';
					$('.header__nav-image').css('background-image', 'url(' + imgUrl + ')');
				} else {
					$('#site-header').css('background', 'transparent');
					$('#site-header').css('box-shadow', 'none');
					$('#primary-menu .menu-item a').css('color', 'white');
					$('#primary-menu .dropdown-menu .menu-item a').css('color', '#212121');
					imgUrl = '/wp-content/themes/brinova/assets/dist/images/brinova-neg.png';
					$('.header__nav-image').css('background-image', 'url(' + imgUrl + ')');
				}
			});
		}

		$('.hamburger').first().click(function () {
			$(this).toggleClass('is-active');

			if ($(this).hasClass('is-active')) {
				$('.main-navigation').addClass('is-active');

			} else {
				$('.main-navigation').removeClass('is-active');

				if ($('.dropdown-menu').hasClass('is-active')) {
					$('.dropdown-menu').removeClass('is-active');
				}
			}

		});

		$('#primary-menu .dropdown > a').click(function (e) {
			if (576 < $(window).width()) {
				return;
			}

			e.preventDefault();
			$('.main-navigation').removeClass('is-active');
			$(this).parent().children('.dropdown-menu').addClass('is-active');

			if (!$('.dropdown-menu.is-active :first-child').hasClass('back-to-d-zero')) {
				$(this).parent().children('.dropdown-menu').prepend($(`<li class="menu-item"><a href="${$(this).attr('href')}">${$(this).text()}</a></li>`));
				$(this).parent().children('.dropdown-menu').prepend($('<li class="back-to-d-zero"></li>').text('Start'));
			}


			$('.back-to-d-zero').click(function () {
				$('.dropdown-menu').removeClass('is-active');
				$('.main-navigation').addClass('is-active');
			});
		});
		// /Header nav

		$('.gb__article .email a').on('click', function () {
			var user = $(this).attr('id')+'@brinova.se';
			$("#input_19_1").val(user);	
			$("#input_19_7").val(user);
			$('html, body').animate({
				scrollTop: $("#input_19_1").offset().top - 250
			}, 700);
		});

		// Search
		var ajaxLock = false;
		$('.item-wrapper').on('click', function () {
			if ('Bostad' === $(this).text()) {
				window.open('https://marknad.brinova.se/ledigt/lagenhet');
				window.focus();
				location.reload(true);
			}

			if ('Förråd' === $(this).text()) {
				window.open('https://www.brinova.se/bolagret/');
				window.focus();
				location.reload(true);
			}

			if ('Parkeringsplats' === $(this).text()) {
				window.open('https://marknad.brinova.se/ledigt/bilplats');
				window.focus();
				location.reload(true);
			}

			if (576 < $(window).width()) {
				return;
			}

			let $that = $('.brinova-select:last-of-type').children('.select-items');
			$that.removeClass('select-hide');
			$that.addClass('open');

			if (!$that.children().hasClass('arrow-back')) {
				let src = '/wp-content/themes/brinova/assets/dist/svg/arrow-left-blue.svg';
				$that.prepend(`
					<div class="arrow-back">
						<img src="${src}">
					</div>
				`);
			};

			$('.arrow-back').click(function () {
				$that.removeClass('open');
				$that.addClass('select-hide');
			});
		});

		$('.select-selected').click(function () {
			if ('departments__search' === $(this).parent().parent().parent().attr('id')) {
				// Removes all children to selector, to avoid multiple elements
				$(this).parent().siblings('.form-group').children('#location').siblings('.select-items').empty();

				let form_id = $(this).parent().parent().parent().attr('id');
				let slug = $(this).attr('data-slug')
				handleInputChange(slug, form_id);
			}

			if (576 < $(window).width()) {
				return;
			}

			if (!$(this).siblings('.select-items').children().hasClass('arrow-back')) {
				let src = '/wp-content/themes/brinova/assets/dist/svg/arrow-left-blue.svg';
				$(this).siblings('.select-items').prepend(`
					<div class="arrow-back">
						<img src="${src}">
					</div>
				`);
			};

			$('.arrow-back').click(function () {
				$(this).parent().removeClass('open');
				$(this).parent().addClass('select-hide');
			});
		});

		// Fronpage search results
		$('#frontpage__search').submit(function (e) {
			e.preventDefault();

			let taxonomy = $(this).children().children('.brinova-select:last').children('.select-selected').data('slug');

			if (typeof (taxonomy) === 'undefined') {
				$(location).attr("href", `/lokaler`);
			} else {
				$(location).attr("href", `/kommun/${taxonomy}`);
			}
		});

		// Departments search results
		$('#departments__search').submit(function (e) {
			e.preventDefault();
		});

		$('#departments__search .btn-search').click(function () {
			$('.all-departments .container').children().show();
			$('.all-departments .container section').children().show();
			let county = 'undefined';
			let city = 'undefined';

			let form_id = $('#departments__search').attr('id');

			county = $(`#${form_id} .brinova-select:first .select-selected`).attr('data-slug');
			$(`#${form_id} .brinova-select:first .select-selected`).removeAttr('data-slug');
			$(`#${form_id} .brinova-select:first .select-selected`).text('Välj din region');

			city = $(`#${form_id} .brinova-select:last .select-selected`).attr('data-name');
			$(`#${form_id} .brinova-select:last .select-selected`).removeAttr('data-name');
			$(`#${form_id} .brinova-select:last .select-selected`).text('Välj din ort');

			// This makes sure that user has selected something
			if (typeof county == 'undefined' && typeof city == 'undefined') {
				return;
			}

			$('.all-departments .container').children().hide();

			if (typeof city !== 'undefined') {
				$('.all-departments .container section').children().hide();
				$(`.all-departments .container h3#${county}`).show();
				$(`.all-departments .container section#${county} #${city}`).show();
			}

			if (typeof county == 'undefined' && typeof city !== 'undefined') {
				$(`.all-departments .container`).append('<h3>Vänligen välj region!</h3>')
			}

			if (typeof county !== 'undefined') {
				$(`.all-departments .container h3#${county}`).show();
				$(`.all-departments .container section#${county}`).show();
			}

		});
		// /Search

		// Render posts departments
		$('.load-more-controls .load-more').on('click', function () {
			let parentId = $(this).parent().parent().attr('id');
			const ids = [];

			$(`#${parentId} > article`).map(function () {
				if ($(this).css('display') == 'none') {
					ids.push(this.id);
				}
			});

			// SET THIS TO WHATEVER NUMBER YOU WANT TO DISPLAY EACH CLICK.
			let number = 5;
			const toBlock = ids.slice(0, number);

			if (ids.length < number) {
				$(this).css('display', 'none');
				$(this).css('visibility', 'hidden');
			}

			toBlock.forEach(id => {
				$(`#${parentId} #${id}`).css('display', 'block');
			});
		});


		$('.all-departments .container > section').each(function () {
			const id = $(this).attr('id');

			$(`section#${id} > article`).each(function () {

				$(`section#${id} > .load-more-controls`).css('display', 'none')
				$(`section#${id} > .load-more-controls`).css('visibility', 'hidden')

				if ($(this).css('display') == 'none') {
					$(`section#${id} > .load-more-controls`).css('display', 'flex')
					$(`section#${id} > .load-more-controls`).css('visibility', 'visible')
				}
			});
		});
		// /Render posts departments

		// Footer nav
		$('.footer-menu .menu-item').on('click', function (e) {

			if (576 < $(window).width()) {
				return;
			}

			e.stopPropagation();
			$(e.target).children('.dropdown-menu').slideToggle(300);
			$(this).toggleClass('expanded');

		});// /Footer nav

		// Estates google map
		$('.show-map').click(function () {
			$('.container-wrapper .container-inner').addClass('is-active');
			$('.close-map').addClass('is-active');
		});

		$('.on-estate-hover').click(function (e) {
			e.preventDefault();

			// scrolls to the top of the google map
			window.scrollTo(0, 432);

			$('.container-wrapper .container-inner').addClass('is-active');
			$('.close-map').addClass('is-active');
		});

		$('.close-map').click(function () {
			$('.container-wrapper .container-inner').removeClass('is-active');
			$(this).removeClass('is-active');
		});
		// /Estates google map

		// Lightbox modal
		$('.desktop-device img').on('click', function () {
			$('.estate-modal').addClass('is-active');
		});

		$('.mobile-device img').on('click', function () {
			$('.estate-modal').addClass('is-active');
		});

		$('.close__estate-modal').click(function () {
			$('.estate-modal').removeClass('is-active');
		});
		// /Lightbox modal

		function menuHeight() {
			let height = $(window).height() - 100;
			if (375 >= $(window).width()) {
				$('.brinova-select .select-items').css('height', `${height}px`);
				$('.main-navigation').css('height', `${height}px`);
				$('.main-navigation .dropdown-menu.depth_0').css('height', `${height}px`);
				$('.estate-online__archive .container-inner').css('height', `${height}px`);
			} else {
				$('.main-navigation').css('height', '');
				$('.main-navigation .dropdown-menu.depth_0').css('height', '');
			}
		};

		function handleInputChange(slug, form_id) {
			let action;

			//console.log(slug);
			if ('departments__search' === form_id) {
				action = 'populate_departments';
			}

			ajaxLock = true;

			$.ajax({
				method: 'POST',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: action,
					slug: slug,
					form: form_id,
				},
				dataType: 'json',
			})
				.done(function (response) {
					//console.log(response);

					if ('departments__search' == response.form) {
						$(`#${response.form} #location`).siblings('.select-items').append(response.content);

						$(`#${response.form} #location`).siblings('.select-items').children().click(function () {
							$(this).parent().siblings('.select-selected').attr('data-name', $.trim($(this).text().replace(/ /g, '')));
							$(this).parent().siblings('.select-selected').text($.trim($(this).text()));

							if (576 < $(window).width()) {
								return;
							}
							$(this).parent().removeClass('open');
							$(this).parent().addClass('select-hide');
						});
					}

					ajaxLock = false;
					console.log('Success');
				})
				.fail(function (jqXHR, textStatus, errorThrown) {
					ajaxLock = false;

					console.log(XMLHttpRequest);
					console.log(textStatus);
					console.log(errorThrown);

					console.log('Failed');
				});
		}

		// Opens the link in a new tab
		$('.menu-btn a').attr('target', '_blank');

		menuHeight();

	});

})(jQuery);
